import { render, staticRenderFns } from "./firmActivity.vue?vue&type=template&id=60dde082&scoped=true&"
import script from "./firmActivity.vue?vue&type=script&lang=js&"
export * from "./firmActivity.vue?vue&type=script&lang=js&"
import style0 from "./firmActivity.vue?vue&type=style&index=0&id=60dde082&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dde082",
  null
  
)

export default component.exports